export default "__VITE_ASSET__C55BU7bQ__"